module.exports = __webpack_public_path__ + "static/media/18ECA49.8a835504.jpg";